import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { createProvider, Step } from '../../../../shared/IFE/step/step/step';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AnalyticsService } from '../../../../shared/modules/analytics/services/analytics.service';
import { PartnerService } from 'src/app/modules/evc-quote/services/partner/partner.service';
import { PartnerUI } from '@app/shared/modules/evc-api/models/partner-ui.interface';
import { Subscription } from 'rxjs';
import { CarValues } from 'src/app/modules/evc-quote/models/constants';

@Component({
  selector: 'app-contact-info',
  providers: [createProvider(ContactInfoComponent)],
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactInfoComponent extends Step implements OnDestroy {
  readonly formName = 'evcSimulator';
  readonly stepName: string = 'contact-info';

  public isPartnerSelectionCar = false;
  private partnerSubscription: Subscription;

  constructor(
    private readonly partnerService: PartnerService,
    fb: UntypedFormBuilder,
    analyticsService: AnalyticsService
  ) {
    super(fb, analyticsService);

    this.partnerSubscription = this.partnerService.restoredPartner$.subscribe((partner: PartnerUI) => {
      if (partner) {
        this.isPartnerSelectionCar = partner && (partner.name || '').toLowerCase() === CarValues.kia;
        if (this.control) {
          this.control.get('gdpr').addValidators(Validators.required);
        }
      } else {
        if (this.control) {
          this.control.get('gdpr').clearValidators();
        }
      }
    });
  }

  public navigate(): void {
    if (this.control.valid) {
      this.onTouch();
      if (!this.isPartnerSelectionCar) {
        delete this.control.value.gdpr;
      }
      this.valueChanges(this.control.value);
    }
    super.navigate();
  }

  protected buildForm() {
    this.control = this.fb.group({
      email: this.fb.control('', [
        Validators.required,
        Validators.email,
        Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,6}$'),
      ]),
      phone: this.fb.control('', [Validators.pattern('^[0-9_/ /-/+]{9,13}$')]),
      newsletter: this.fb.control('', []),
      // GDPR compliance is set only for partner KIA
      gdpr: this.fb.control('', this.isPartnerSelectionCar ? [Validators.requiredTrue] : []),
    });
  }

  ngOnDestroy(): void {
    if (this.partnerSubscription) {
      this.partnerSubscription.unsubscribe();
    }
  }
}
